import React from 'react';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  title: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
  },
}));

const Title = () => {
  const classes = useStyles();

  return (
    <Typography className={classes.title} variant="h5" component="h1" color="inherit">
      ScopeOne
    </Typography>
  );
};

export default Title;
